import { Box, TableCell, TableSortLabel } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import React, { FC, useCallback } from 'react';
import { Order, StatusRequestOrderBy } from '../../interfaces';
import { useTranslation } from '../../services';

interface ManageRequestsTableHeadInterface {
	title: string;
	order: Order;
	columnName: StatusRequestOrderBy;
	orderBy: StatusRequestOrderBy | undefined;
	onRequestSort: (
		event: React.MouseEvent<unknown>,
		property: StatusRequestOrderBy
	) => void;
}
const ManageRequestsTableHead: FC<ManageRequestsTableHeadInterface> = ({
	columnName,
	onRequestSort,
	orderBy,
	order,
	title,
}) => {
	const { t } = useTranslation();
	const createSortHandler = useCallback(
		(property: StatusRequestOrderBy) => (event: React.MouseEvent<unknown>) => {
			onRequestSort(event, property);
		},
		[onRequestSort]
	);

	return (
		<TableCell sortDirection={orderBy === columnName ? (order as any) : false}>
			<TableSortLabel
				active={orderBy === columnName}
				direction={orderBy === columnName ? (order as any) : Order.ASC}
				onClick={createSortHandler(columnName as StatusRequestOrderBy)}
			>
				{t(title)}
				{orderBy === columnName ? (
					<Box component="span" sx={visuallyHidden}>
						{order === Order.DESC ? 'sorted descending' : 'sorted ascending'}
					</Box>
				) : null}
			</TableSortLabel>
		</TableCell>
	);
};

export default ManageRequestsTableHead;
